<div>{{ secondsToTime(time) }}</div>